import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

// Components
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import Project from "./Components/Project";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import Pays from "./Components/Pays";
import Notpay from "./Components/Notpay";

function App() {
  return (
    <div className="App">
    <Router>
      <Navbar />

      <Routes>
        {/* Default route redirects to /home */}
        <Route path="/" element={<Navigate to="/home" replace />} />

        <Route path="/home" element={<Home />} />
        <Route path="/projects" element={<Project />} />
        <Route path="/contact" element={<Contact />} />

        {/* Keep all paths lowercase to avoid issues */}
        <Route path="/pays" element={<Pays />} />
        <Route path="/notpay" element={<Notpay />} />

      


        {/* Catch unknown routes */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>

      <Footer />
    </Router>
    </div>
  );
}

export default App;
